( function( $ ){

  const $body = $( 'body' );
  const $header = $( '#site-header' );

  const $menu = $( '#menu-wrap', $header );
  const $toggle = $( '#mobile-menu-toggle', $header );
  const speed = 300;

  const menu_bp = $header.data( 'menu-bp' );


  if ( !$header.hasClass( 'opaque' ) ) {

    const $opacity_px = $( "<span class='opacity-px'></span>" );
    $opacity_px.appendTo( $body );

    const opacity_observer = new IntersectionObserver( set_opacity, {
      root: document,
      threshold: 1
    });

    opacity_observer.observe( $opacity_px.get(0) );

    function set_opacity ( entries ) {
      // console.log( entries );
      $header.toggleClass( 'opaque', ( entries[0].intersectionRatio < 1 ) );
    }
  }


  function is_mobile () {
    return $toggle.is( ':visible' );
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap( $header.get(0), {
    onActivate () {
      $toggle.addClass( 'is-active' );
      $menu.addClass( 'visible' );
      $body.addClass( 'menu-open' );
    },
    onDeactivate () {
      $toggle.removeClass( 'is-active' );
      $body.removeClass( 'menu-open' );
      setTimeout( function () {
        $menu.removeClass( 'visible' );
      }, speed );
    },
    initialFocus: $toggle.get(0),
  });


  function resize () {
    $header.toggleClass( 'mobile', !ThemeJS.Media_Queries.is_at_least( menu_bp ) );
    document.querySelector( ':root' ).style.setProperty( '--header-height', `${ $header.outerHeight() }px` );
    $body.removeClass( 'mobile-transition-enabled' );
    setTimeout( function () {
      $body.addClass( 'mobile-transition-enabled' );
    }, 0 );
    if ( ThemeJS.Media_Queries.is_at_least( menu_bp ) ) {
      focus_trap.deactivate();
      $( 'button.sub-menu-toggle' ).closest( 'li' ).each( function () {
        set_submenu_open( $(this), false );
      });
    }
  }


  // init header pad height and set header to fixed
  resize();
  $header.addClass( 'fixed' );
  // trigger height recalculation on breakpoint change
  $( window ).on( 'breakpoint_changed', resize );

  // toggle mobile menu on hamburger click
  $toggle.click( () => {
    $body.hasClass( 'menu-open' ) ? focus_trap.deactivate() : focus_trap.activate();
  });


  // function to set submenus open/close
  function set_submenu_open ( $li, opening ) {
    let $btn = $( '> .link-wrap button.sub-menu-toggle', $li );
    if ( !$btn.length ) { return; }
    let $submenu = $( `#${ $btn.attr( 'aria-controls' ) }` );
    if ( !$submenu.length ) { return; }
    $btn.attr( 'aria-expanded', opening ? 'true' : 'false' );
		$submenu.attr( 'aria-hidden', opening ? 'false' : 'true' )[ opening ? 'slideDown' : 'slideUp' ]( speed );
  }


  // toggle submenus on click of caret btns
  $menu.on( 'click', 'button.sub-menu-toggle', function () {
    set_submenu_open( $(this).closest( 'li' ), $(this).attr( 'aria-expanded' ) == 'false' );
  });


  // close submenu on tab out
  $menu.on( 'focusout', 'li.menu-item-has-children', function ( e ) {
    if ( is_mobile() || $.contains( this, e.relatedTarget ) ) { return; }
    set_submenu_open( $(this), false );
  });


  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on( 'click', 'a[href="#"]', function ( e ) {
    e.preventDefault();
    let $btn = $( '+ .sub-menu-toggle', this );
    if ( $btn.length ) {
      $btn.click();
    }
  });



  const $menu_top_lvl_items = $( '.menu > li', $menu );
  let menu_pos_debounce;
  function calc_menu_pos () {
    if ( ThemeJS.Media_Queries.is_at_least( menu_bp ) ) {
      $menu_top_lvl_items.each( function () {
        const $this = $(this);
        $this.removeClass( 'align-right' );
        setTimeout( () => {
          $( 'ul.sub-menu', this ).each( function () {
            // console.log( window.innerWidth - this.getBoundingClientRect().right );
            if ( ( window.innerWidth - this.getBoundingClientRect().right ) < 100 ) {
              $this.addClass( 'align-right' );
              return false;
            }
          });
        }, 0 );
      });
    }
  }
  calc_menu_pos();
  $( window ).on( 'resize', function () {
    clearTimeout( menu_pos_debounce );
    setTimeout( function () {
      calc_menu_pos();
    }, 50 );
  });


})( jQuery );
